import toast from 'react-hot-toast'

import { XIcon } from 'components/icons/Icon'
import styles from './styles/ToastContentContainer.css'

interface ToastContentContainerProps {
  mainText: string
  toastID: string
  actionLabel?: string | null
  actionHandler?: (() => void) | null
}

export const ToastContentContainer = ({
  mainText,
  toastID,
  actionLabel,
  actionHandler
}: ToastContentContainerProps) => {
  return (
    <span className={styles.toastContainer}>
      <span className={styles.toastText}>{mainText}</span>
      {actionLabel && actionHandler && (
        <span className={styles.toastActionLink} onClick={actionHandler}>
          {actionLabel}
        </span>
      )}
      <span
        className={styles.toastDismissIcon}
        onClick={() => toast.dismiss(toastID)}
        title='Dismiss'
        role='button'
        tabIndex={0}
        aria-label='Dismiss'
      >
        <XIcon size={18} />
      </span>
    </span>
  )
}

export default ToastContentContainer
